export const stylesGenericInputLabelCP = {
  wrapper: {
    fontSize: "12px",
    color: "#474747",
    fontFamily: "RobotoBold",
  },
  image: {
    verticalAlign: "middle",
    margin: "auto 8px",
    width: "18px",
  },
  label: { margin: "auto" },
};

export const stylesGenericInputLabelContainerTerlcel = {};
